// @ts-nocheck
import * as actions from './designPanelActions';
import * as selectors from './designPanelSelectors';
import reducer from './designPanelReducer';

export { actions, selectors, reducer };
